module.exports = __webpack_public_path__ + "static/media/journo-head-icon.7a9aeb7b.svg";